import React from 'react';
import styles from "./ModalPrimary.module.scss";
import BtnPrimary from "./BtnPrimary";
import BtnSecondary from "./BtnSecondary";
import BtnSvg from "./BtnSvg";

const ModalPrimary = ({
                          textTitle,
                          textComment,
                          textBtnValidate = "Valider",
                          textBtnCancel = "Annuler",
                          textURL = "",
                          URL = "",
                          showValidateBtn = true,
                          showCancelBtn = true,
                          onCancel,
                          onValidate,
                          children
                      }) => {

    // Conditionner l'affichage des boutons en fonction de la présence des fonctions `onValidate` et `onCancel`
    const showValidateButton = showValidateBtn && onValidate;
    const showCancelButton = showCancelBtn && onCancel;

    // Empêche la propagation des clics sur le fond de la modal
    const handleModalClick = (event) => {
        event.stopPropagation();
    };

    return (
        <div className={`${styles.modalPrimaryContent}`} onClick={handleModalClick}>
            <div className={`${styles.modalPrimary}`} onClick={(event) => event.stopPropagation()}>
                <div className={`${styles.modalPrimaryHeader}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="140" height="87" viewBox="0 0 140 87"
                         fill="none">
                        <g clipPath="url(#clip0_334_3224)">
                            <path
                                d="M140 5.91682C140 6.27174 140 6.62666 139.986 6.9681C139.429 51.3106 103.365 86.9822 58.981 86.9822H5.95795C5.44608 86.9822 4.96565 86.9193 4.52113 86.8115C4.50766 86.798 4.4897 86.798 4.47623 86.798C4.27418 86.7531 4.09009 86.6902 3.9015 86.6273C2.62184 86.1646 1.61606 85.311 0.951536 84.2327C0.888675 84.1564 0.857245 84.062 0.798874 83.9677C0.569881 83.5229 0.354359 83.0242 0.224147 82.4986C0.116386 82.0673 0.0535248 81.636 0.0355645 81.1822C-0.0587267 81.1822 0.066995 5.96175 0.0220944 5.91233C0.0220944 2.64168 2.66225 0 5.93999 0H134.185C134.648 0.013478 135.083 0.0763751 135.514 0.170721C135.514 0.184199 135.528 0.184199 135.546 0.184199C137.108 0.570567 138.311 1.51402 139.07 2.754C139.133 2.83037 139.178 2.92472 139.223 3.01906C139.376 3.28413 139.501 3.57615 139.596 3.86817C139.627 3.93107 139.658 3.98948 139.672 4.05687C139.717 4.19614 139.766 4.33541 139.793 4.48816C139.914 4.91945 139.964 5.35075 139.982 5.80451C139.982 5.84045 140 5.87639 140 5.92132V5.91682Z"
                                fill="#F82121"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_334_3224">
                                <rect width="140" height="86.9822" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                    {
                        showCancelButton ? (<BtnSvg svg={"croix"} width={32} height={32} onClick={onCancel}/>) : null
                    }
                </div>
                <div className={`${styles.modalPrimaryBody}`}>
                    <div className={`${styles.modalPrimaryContentText}`}>
                        <div className={`${styles.modalPrimaryTitle}`}>
                            {textTitle}
                        </div>
                        <div className={`${styles.modalPrimaryComment}`}>
                            {children}
                            {textComment}
                        </div>
                        <div>
                            {textURL || URL ? (
                                <a
                                    href={URL}
                                    target="_blank"
                                    style={{
                                        color: "var(--SEIZO-dark, #002335)",
                                        textDecoration: "none",
                                        borderBottom: "2px solid #00B0FF",
                                    }}
                                >{textURL ? textURL : URL}</a>
                            ) : null}
                        </div>
                    </div>
                    {
                        showValidateButton ? (<BtnPrimary onClick={(e) => { e.stopPropagation(); onValidate(); }}>{textBtnValidate}</BtnPrimary>) : null
                    }
                    {
                        showCancelButton ? (<BtnSecondary onClick={(e) => { e.stopPropagation(); onCancel(); }}>{textBtnCancel}</BtnSecondary>) : null
                    }
                </div>
                <div className={`${styles.modalSvgBis}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100"
                         fill="none">
                        <path
                            d="M49.9806 99.9799H5.95832C5.35265 99.9799 4.78322 99.8919 4.2345 99.7314C1.93606 99.0378 0.227772 97.0033 0.0155293 94.5289C-6.32368e-07 94.3684 0 94.1872 0 94.0319V49.989C0 21.2172 24.3199 -1.89137 53.5369 0.122342C66.9341 1.04896 78.9594 7.35412 87.4077 16.905C94.5153 24.9081 99.1121 35.2045 99.8783 46.4637C101.887 75.6807 78.7783 99.9851 49.9909 99.9851L49.9806 99.9799Z"
                            fill="#FF9436"/>
                    </svg>
                </div>
                <div className={`${styles.modalPrimaryfooter}`}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="107" height="160" viewBox="0 0 107 160"
                         fill="none">
                        <g clipPath="url(#clip0_334_3229)">
                            <path
                                d="M13.6319 160L99.1429 160C103.17 160 106.385 156.747 106.385 152.758L106.385 7.24725C106.385 6.64285 106.308 6.06043 106.176 5.50549C106.176 5.48901 106.176 5.46703 106.159 5.45054C106.104 5.20329 106.027 4.97802 105.951 4.74725C105.385 3.18131 104.341 1.95054 103.022 1.13736C102.929 1.06043 102.813 1.02197 102.72 0.967027C102.308 0.736258 101.868 0.554939 101.451 0.401093C101.264 0.346148 101.088 0.285709 100.923 0.252742C100.379 0.120873 99.8461 0.0439503 99.2967 0.0219723C99.2418 0.0219723 99.2033 0.00548883 99.1483 0.00548883C71.7692 0.00549003 46.9945 11.1044 29.033 29.033C11.0989 46.9725 3.13761e-06 71.7857 4.33343e-06 99.1429L6.39723e-06 146.357C6.72651e-06 153.89 6.1099 159.995 13.6319 159.995L13.6319 160Z"
                                fill="#66BE63"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_334_3229">
                                <rect width="160" height="106.385" fill="white"
                                      transform="matrix(4.37114e-08 1 1 -4.37114e-08 0 0)"/>
                            </clipPath>
                        </defs>
                    </svg>
                </div>

            </div>
        </div>
    );
};

export default ModalPrimary;